import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'ui-icon-mobile-mode-list',
    templateUrl: './icon-mobile-mode-list.component.svg',
    styleUrls: ['../icon-base.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
})
export class IconMobileModeListComponent { }
